import React from "react";      
import LogoutContent from "../../components/Auth/LogoutContent";

const Logout = () => {
  return (
    <>
      <LogoutContent />
    </>
  );
};

export default Logout;
